import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
export var useCoordination = function useCoordination(coordinationClient, messageId) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    started = _useState2[0],
    setStarted = _useState2[1];
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _started;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return coordinationClient.start(messageId);
          case 3:
            _started = _context.sent;
            if (_started) {
              setStarted(true);
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.error("Unable to start flow message ".concat(messageId, ". ").concat(_context.t0));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }, [coordinationClient, messageId]);
  var stop = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(force) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!force && !started)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return coordinationClient.stop(messageId);
          case 5:
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](2);
            // eslint-disable-next-line no-console
            console.error("Unable to stop flow message ".concat(messageId, ". ").concat(_context2.t0));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 7]]);
    }));
    return function stop(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return [started, stop];
};